<template>
    <router-view
      :filters_controller='filters_controller'
      :content_state='content_state'
    >
    </router-view>
</template>

<script setup>
  import { onBeforeMount, reactive, watch } from 'vue';
  import { useRoute }                       from 'vue-router';
  import FiltersController                  from '@/js/Settings/Filters/FiltersController.js';
  import ContentState                       from '@/js/Shared/State/ContentState.js';

  const filters_controller = reactive(new FiltersController());
  const content_state      = reactive(new ContentState());
  const route              = useRoute();

  watch(() => route.params.id, () => {
    validateRoute();
  });

  content_state.onErrorRetry(async () => {
    await fetchFilters();
  })

  onBeforeMount(async () => {
    await fetchFilters();
    validateRoute();
  })

  const fetchFilters = async () => {
    content_state.setLoading();
    content_state.setLoadedState(
      await filters_controller.fetchFilters()
    );
  }

  const validateRoute = () => {
    if (route.name === 'filters-edit') {
      validateFiltersId();
      return;
    }

    if (route.name === 'filters-info') {
      validateFiltersId();
      return;
    }
  }

  const validateFiltersId = () => {
    content_state.setFoundState(
      filters_controller.data.filters.exists(route.params.id)
    );
  }
</script>